import { Validator } from '@vista-digital/validator';
import { defaultLoyaltyAuthenticationConfig, loyaltyAuthenticationConfigValidator } from './loyalty-authentication';
export const defaultLoyaltyConfig = {
    authentication: defaultLoyaltyAuthenticationConfig,
    onSignedOut: undefined,
    onSignedOutFailed: undefined
};
export const loyaltyConfigValidator = Validator.object({
    authentication: loyaltyAuthenticationConfigValidator,
    onSignedOut: Validator.optional(Validator.fn()),
    onSignedOutFailed: Validator.optional(Validator.fn())
});
//# sourceMappingURL=loyalty.js.map